import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ResendConfirmationService } from './resend-confirmation.service';

@Component({
  selector: 'app-resend-confirmation',
  templateUrl: './resend-confirmation.component.html',
  styleUrls: ['./resend-confirmation.component.scss']
})
export class ResendConfirmationComponent implements OnInit {
  formResend: FormGroup;
  wait = false;
  response = '';
  typeResponse ='';

  constructor(private rcs:ResendConfirmationService) {
    this.formResend = new FormGroup({
      email: new FormControl('',
        [
          Validators.required,
          Validators.pattern('^[a-zA-Z0-9\._-]+@[a-zA-Z0-9-]{2,}([.][a-zA-Z]{2,64}){1,64}$')
        ]
      )
    });
   }

  ngOnInit() {
  }

  submitResend(){
    this.wait = true;
    this.typeResponse = '';
    this.rcs.sendResendRequest(this.formResend.value).subscribe(
      (response)=>{
        this.typeResponse = 'info';
        this.wait = false;
        const message = Object(response)['data'].message;
        this.response = message;
        this.formResend.get('email').setValue('');
      },
      (error)=>{
        this.typeResponse = 'danger';
        this.wait = false;
        const message = Object(error)['error'].message;
        this.response = message;
      }
    )
  }

}